// extracted by mini-css-extract-plugin
export default {"portal":"_2_WUly6l","reveal":"_2x4UxCWs","root":"_2Hd3gxLT","revealUp":"_1DtVJcmY","small":"i4jqTAtK","medium":"V4Cm4PZH","large":"_9QDMzEGE"};